import { createContext, useContext, type ReactNode } from 'react'

import type { HomeWidgetDefinition } from '@/lib/home-widgets'

const HomeWidgetsContext = createContext<readonly HomeWidgetDefinition[]>([])

export function HomeWidgetsProvider({
  widgets,
  children,
}: {
  widgets: readonly HomeWidgetDefinition[]
  children: ReactNode
}) {
  return <HomeWidgetsContext value={widgets}>{children}</HomeWidgetsContext>
}

export function useHomeWidgets() {
  return useContext(HomeWidgetsContext)
}
